import { AxiosPromise } from "axios";
import {
  InviteUserDto,
  MemberDto,
  RegisterDto,
  UsersResourceApi,
} from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";

const api = new UsersResourceApi(dashboardApiConfig);

const UsersApi = {
  inviteUser(dtos: InviteUserDto[]): AxiosPromise<number[]> {
    return api.inviteUser(dtos, ops());
  },
  validateUsers(dtos: InviteUserDto[]): AxiosPromise<void> {
    return api.validateTeamUsers(dtos, ops());
  },
  register(dto: RegisterDto): AxiosPromise<string> {
    return api.register(dto, ops());
  },
  revokeInvitation(id: string): AxiosPromise<void> {
    return api.revokeInvitation(id, ops());
  },
  removeUser(id: string): AxiosPromise<void> {
    return api.removeUser(id, ops());
  },
  revokeUser(id: string): AxiosPromise<void> {
    return api.revokeUser(id, ops());
  },
  sendInvitationEmail(id: string): AxiosPromise<void> {
    return api.sendInvitationEmail(id, ops());
  },
  getUserInvite(id: string): AxiosPromise<MemberDto> {
    return api.getUserInvite(id, ops());
  },
};

export default UsersApi;
